<template>
  <div class="full d-flex justify-center">
    <div class="breakpoint d-flex align-center justify-center">
      <div class="intro" v-if="!testRunning">
        <div class="temp-log d-flex justify-center mb-3">
          <img
            src="../../assets/img/logo-teman-bakat.png"
            height="100px"
            alt=""
          />
        </div>
        <v-card flat class="rounded-max pa-3 mb-5">
          <div v-if="instruction">
            <p class="text-center">
              {{ instruction.pertanyaan }}
            </p>
            <small class="grey--text"
              >*Pengerjaan journey memiliki batas waktu</small
            >
          </div>
          <v-skeleton-loader
            v-if="!instruction"
            type="list-item-three-line"
          ></v-skeleton-loader>
        </v-card>
        <v-btn rounded color="#1E656C" dark block @click="start"
          >Mulai Journey</v-btn
        >
      </div>
      <div class="intro my-5" v-if="testRunning">
        <div class="d-flex align-center mb-5">
          <div class="temp-bar mr-2">
            <v-progress-linear
              color="#1E656C"
              :value="percent"
              rounded
              class="mr-2"
              height="10"
            ></v-progress-linear>
          </div>
          <div>
            <v-btn
              dark
              fab
              small
              color="#1E656C"
              @click="dialogInstruction = true"
              content="Instruksi"
              v-tippy="{
                arrow: true,
                arrowType: 'round',
                animation: 'fade',
                theme: 'light',
              }"
            >
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex" v-if="!loadingQuest">
          <div class="quest">
            <draggable
              v-model="question"
              class="list-group mr-3"
              @start="drag = true"
              @end="draged"
              v-bind="dragOptions"
            >
              <transition-group
                type="transition"
                :name="!drag ? 'flip-list' : null"
              >
                <v-card
                  v-for="item in question"
                  class="pa-3 mb-3 d-flex card-q draged"
                  :key="item.id"
                >
                  <div>
                    <img :src="item.path" height="70px" alt="" />
                  </div>
                  <div class="d-flex justify-center align-center ml-2">
                    {{ item.pertanyaan }}
                  </div>
                </v-card>
              </transition-group>
            </draggable>
          </div>
          <div class="rank">
            <v-card
              v-for="i in 6"
              :key="i"
              class="pa-3 mb-3 d-flex justify-center align-center card-q"
              flat
              color="#1E656C"
              ><h2 class="white--text">{{ i }}</h2></v-card
            >
          </div>
        </div>
        <div class="d-flex" v-if="loadingQuest">
          <div class="quest">
            <v-skeleton-loader
              v-for="i in 6"
              :key="i"
              type="image"
              class="mr-3 mb-3 card-q"
            ></v-skeleton-loader>
          </div>
          <div class="rank">
            <v-skeleton-loader
              v-for="i in 6"
              :key="i"
              type="image"
              class="mb-3 card-q"
            ></v-skeleton-loader>
          </div>
        </div>
        <div class="paginate d-flex justify-center align-center">
          <div v-if="page > 1">
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="!loadingPrev"
              @click="paginate('prev')"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingPrev"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
          <div v-if="last_page !== page">
            <v-btn
              dark
              fab
              small
              color="#1E656C"
              v-if="!loadingNext"
              @click="paginate('next')"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              dark
              fab
              small
              class="mr-3"
              color="#1E656C"
              v-if="loadingNext"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-btn>
          </div>
          <div v-if="last_page == page">
            <v-btn
              dark
              rounded
              v-if="!loadingSubmit"
              color="#1E656C"
              @click="paginate('done')"
            >
              Selesai
            </v-btn>
            <v-btn
              dark
              rounded
              class="mr-3"
              color="#1E656C"
              v-if="loadingSubmit"
            >
              <v-progress-circular
                class="mr-2"
                indeterminate
              ></v-progress-circular>
              Menyimpan Jawaban...
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="instruction">
        <Instruction
          v-bind:dialogInstruction="dialogInstruction"
          v-bind:data="instruction"
          @close="closeDialog"
        />
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Instruction from "../instruction/instruction.vue";
export default {
  name: "tespilihankerja",
  components: {
    draggable,
    Instruction,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  data() {
    return {
      id: 1,
      list: [],
      instruction: null,
      question: null,
      testRunning: false,
      drag: false,
      page: 1,
      last_page: null,
      loadingNext: false,
      loadingPrev: false,
      loadingSubmit: false,
      loadingQuest: false,
      page1: null,
      page2: null,
      page3: null,
      percent: 100,
      second: null,
      timerTest: null,
      dialogInstruction: false,
      doneTest: false,
    };
  },
  mounted() {
    this.getInstruction();
    let curent_page = parseInt(localStorage.getItem("curent_page"));
    let last_page = localStorage.getItem("last_page");
    if (last_page) {
      this.last_page = last_page;
    }
    if (curent_page) {
      this.page = curent_page;
    }
    for (let i = 0; i < 3; i++) {
      this.getQuestion(i + 1);
    }
    let statusTest = localStorage.getItem("testRunning")
      ? localStorage.getItem("testRunning")
      : false;
    if (statusTest) {
      this.progresBar();
    }
    this.testRunning = statusTest;
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timerTest);
    for (let i = 1; i <= 3; i++) {
      localStorage.removeItem(`answer-${i}`);
      localStorage.removeItem(`page-${i}`);
    }
    localStorage.removeItem("user-answer");
    localStorage.removeItem("curent_page");
    localStorage.removeItem("testRunning");
    localStorage.removeItem("last_page");
    localStorage.removeItem("remaining-time");
    next();
  },
  methods: {
    getInstruction() {
      this.$store
        .dispatch("instruksi", this.id)
        .then((data) => {
          this.instruction = data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    paginate(status) {
      window.scrollTo(0, 0);
      this.loadingQuest = true;
      if (status == "next") {
        localStorage.setItem(
          `page-${this.page}`,
          JSON.stringify(this.question)
        );
        this.mutateAnswer(this.question, this.page);
        this[`page${this.page}`] = this.question;
        this.page = this.page + 1;
        localStorage.setItem("curent_page", this.page);
        this.loadSoal();
      } else if (status == "prev") {
        localStorage.setItem(
          `page-${this.page}`,
          JSON.stringify(this.question)
        );
        this.mutateAnswer(this.question, this.page);
        this[`page${this.page}`] = this.question;
        this.page = this.page - 1;
        localStorage.setItem("curent_page", this.page);
        this.loadSoal();
      } else if (status == "done") {
        localStorage.setItem(
          `page-${this.page}`,
          JSON.stringify(this.question)
        );
        this.mutateAnswer(this.question, this.page, status);
      }
    },
    loadSoal() {
      let mutatedQuestion = JSON.parse(
        localStorage.getItem(`page-${this.page}`)
      );
      if (mutatedQuestion) {
        this.question = mutatedQuestion;
      } else {
        this.question = this[`page${this.page}`];
      }
      setTimeout(() => {
        this.loadingQuest = false;
      }, 800);
    },
    getQuestion(page) {
      this.loadingQuest = true;
      let data = {
        id: this.id,
        page: page,
      };
      this.$store
        .dispatch("question", data)
        .then((data) => {
          this.second = data.waktu[0].waktu * 60;
          this.loadingQuest = false;
          let current = data.current_page;
          if (current == 1) {
            this.page1 = data.data;
          } else if (current == 2) {
            this.page2 = data.data;
          } else if (current == 3) {
            this.page3 = data.data;
          }
          this.last_page = data.last_page;
          this.loadSoal();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    mutateAnswer(data, page, done) {
      let tempAnswer = [];
      data.forEach((item) => {
        tempAnswer.push({
          id: item.id,
          category: item.kategori,
          code: item.code,
          idx: data.findIndex((x) => x.id === item.id) + 1,
        });
      });

      localStorage.setItem(`answer-${page}`, JSON.stringify(tempAnswer));
      if (done) {
        let allAnswer = [];
        for (let i = 1; i <= this.last_page; i++) {
          allAnswer.push(...JSON.parse(localStorage.getItem(`answer-${i}`)));
          if (i == this.last_page) {
            this.done(allAnswer);
          }
        }
      }
    },
    start() {
      this.testRunning = true;
      localStorage.setItem("testRunning", this.testRunning);

      localStorage.setItem("last_page", this.last_page);
      this.progresBar();
    },
    done(answer) {
      this.loadingSubmit = true;
      let result = {};
      for (let i = 1; i <= this.last_page; i++) {
        result[i] = answer.filter((j) => {
          return j.category == i;
        });
      }
      let finalResult = {};
      let val = {};
      for (const key in result) {
        result[key].forEach((e) => {
          val[e.code] = e.idx.toString();
        });
        finalResult[key] = val;
      }
      let body = { jawaban: JSON.stringify(finalResult) };
      let data = {
        id: this.id,
        body: body,
      };
      this.done = true;
      this.$store
        .dispatch("postAnswer", data)
        .then((data) => {
          this.loadingSubmit = false;
          console.log(data.hasil);
          let storage = {
            answer: body,
            result: JSON.stringify(data.hasil.preference),
          };
          localStorage.setItem("tespilihankerja", JSON.stringify(storage));
          clearInterval(this.timerTest);
          for (let i = 1; i <= 3; i++) {
            localStorage.removeItem(`answer-${i}`);
            localStorage.removeItem(`page-${i}`);
          }
          localStorage.removeItem("user-answer");
          localStorage.removeItem("curent_page");
          localStorage.removeItem("testRunning");
          localStorage.removeItem("last_page");
          localStorage.removeItem("remaining-time");
          let completedMission = JSON.parse(localStorage.getItem("completed"));
          if (completedMission) {
            let isAnswered = completedMission.filter((i) => i.id == this.id);
            if (!isAnswered.length) {
              completedMission.push({
                id: this.id,
                journey: "Tes Pilihan Kerja",
                order: completedMission.length + 1,
                img: `https://nos.wjv-1.neo.id/temanbakat/misi/icon/${this.id}.png`,
              });
              localStorage.setItem(
                "completed",
                JSON.stringify(completedMission)
              );
            }
          } else {
            let mission = [
              {
                id: this.id,
                journey: "Tes Pilihan Kerja",
                order: 1,
                img: `https://nos.wjv-1.neo.id/temanbakat/misi/icon/${this.id}.png`,
              },
            ];
            localStorage.setItem("completed", JSON.stringify(mission));
          }
          this.$router.push("/result/tespilihankerja");
        })
        .catch((err) => {
          console.log(err);
          this.loadingSubmit = false;
        });
    },
    progresBar() {
      let remainingTime = localStorage.getItem("remaining-time"); // waktu tersisa
      let runningTime = null; // detik berjalan
      if (remainingTime) {
        runningTime = remainingTime;
      } else {
        runningTime = this.second;
      }
      this.timerTest = setInterval(() => {
        runningTime--;
        this.percent = (runningTime / this.second) * 100;
        localStorage.setItem("remaining-time", runningTime);
        if (runningTime == 0) {
          clearInterval(this.timerTest);
        }
      }, 1000);
    },
    closeDialog() {
      this.dialogInstruction = false;
    },
    draged() {
      this.drag = false;
      localStorage.setItem(`page-${this.page}`, JSON.stringify(this.question));
    },
  },
};
</script>

<style scoped>
.rank {
  width: 25%;
}
.quest {
  width: 75%;
}
.temp-bar {
  width: 90%;
}
.card-q {
  height: 90px;
}
.draged {
  cursor: grab;
}
@media (max-width: 576px) {
  .card-q {
    height: 120px;
  }
}
@media (max-width: 396px) {
  .card-q {
    height: 120px;
  }
}
</style>
